import React, { useState } from "react";
import { Chart } from "primereact/chart";
import { Dropdown } from "primereact/dropdown";

const rankingTypes = [
    { label: "Regular", value: "regular" },
    { label: "Pro", value: "pro" },
    { label: "Elite", value: "elite" }
];

const gameModes = [
    { label: "Overall", value: "overall" },
    { label: "Moving", value: "moving" },
    { label: "No Move", value: "nomove" },
    { label: "NMPZ", value: "nmpz" }
];

const getMaxRankForPoints = (rankingType, gameMode) => {
    if (rankingType === "elite") return 30;
    if (rankingType === "pro") return 100;
    if (rankingType === "regular") {
        switch (gameMode) {
            case "overall": return 5000;
            case "moving": return 2500;
            case "nomove": return 3000;
            case "nmpz": return 500;
            default: return 5000;
        }
    }
    return 5000;
};

const InteractiveChart = () => {
    const [rankingType, setRankingType] = useState("regular");
    const [gameMode, setGameMode] = useState("overall");

    const maxRankForPoints = getMaxRankForPoints(rankingType, gameMode);
    const steepness = 3; // Fixed value

    const generateData = () => {
        const xValues = Array.from({ length: maxRankForPoints }, (_, i) => i + 1);
        const yValues = xValues.map(rank =>
            rank > maxRankForPoints
                ? 0
                : Math.floor(1000 * (1 - Math.log10(1 + (rank - 1) / steepness) / Math.log10(1 + (maxRankForPoints - 1) / steepness)))
        );

        return {
            labels: xValues,
            datasets: [
                {
                    label: `Points vs Rank (${rankingType.toUpperCase()}, ${gameMode})`,
                    data: yValues,
                    borderColor: '#093a4a',
                    backgroundColor: '#2e6f5a',
                    fill: true,
                    tension: 0.4,
                }
            ]
        };
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                title: { display: true, text: "Rank" }
            },
            y: {
                title: { display: true, text: "Points" },
                min: 0,
                max: 1000,
                ticks: { stepSize: 100 }
            }
        }
    };

    return (
        <div className="p-4">
            <h2>Interactive Points Distribution</h2>

            <Chart type="line" data={generateData()} options={options} style={{ height: "400px" }} />

            <div className="p-mt-4 col-12 grid">
                {/* Ranking Type Selection */}
                <div className="p-mb-3 col-5 col-offset-1 text-center">
                    <label>Ranking Type:&nbsp;</label>
                    <Dropdown value={rankingType} options={rankingTypes} onChange={(e) => setRankingType(e.value)} />
                </div>

                {/* Game Mode Selection (only if Regular is selected) */}
                {rankingType === "regular" && (
                    <div className="p-mb-3 col-5 text-center">
                        <label>Game Mode:&nbsp;</label>
                        <Dropdown value={gameMode} options={gameModes} onChange={(e) => setGameMode(e.value)} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default InteractiveChart;
